import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Button,
  ListItem,
  Stack,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import { SxProps, useTheme } from "@mui/material/styles";
import { useState } from "react";

export type DropdownOptions = {
  label: string;
  value: string;
};

type Props = {
  items: DropdownOptions[];
  loading?: boolean;
  onSelectItem: Function;
  selected: string[];
  label?: string;
  error?: boolean;
  helperText?: string | boolean;
  isEdited?: boolean;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  width?: string;
  sx?: SxProps;
  maxWidthOption?: string;
  minWidthOption?: string;
  fullWidth?: boolean;
};

function AutoCompleteMultiSelect(props: Props) {
  const {
    items,
    onSelectItem,
    selected,
    label,
    loading,
    error,
    helperText,
    isEdited,
    placeholder,
    disabled,
    required,
    width,
    maxWidthOption,
    minWidthOption,
    fullWidth = false,
    ...restProps
  } = props;
  const [inputValue, setInputValue] = useState("");
  const theme = useTheme();

  useEffect(() => {
    setInputValue("");
  }, [selected]);

  return (
    <Autocomplete
      multiple
      disablePortal
      options={items}
      disabled={disabled}
      loading={loading}
      getOptionLabel={(option) => option.label || ""}
      onChange={(event, value) => {
        onSelectItem(value.map((item) => item.value));
      }}
      inputValue={inputValue}
      value={items.filter((item) => selected.includes(item.value))}
      fullWidth={fullWidth}
      ListboxProps={{
        style: { maxHeight: 400, overflowY: "auto" },
      }}
      size="small"
      sx={{ m: 1, minWidth: width ?? "120px", maxWidth: width }}
      {...restProps}
      renderInput={(params) => (
        <Box className="input-wrapper">
          <TextField
            {...params}
            error={error}
            className={isEdited ? "not-edited" : ""}
            placeholder={placeholder || "Search..."}
            label={label}
            required={required}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
          />
          <Typography style={{ fontSize: 12 }} color={theme.palette.error.main}>
            {helperText}
          </Typography>
          {isEdited && (
            <Button
              className="close_btn"
              onClick={() => {
                onSelectItem([]);
              }}
            >
              <CloseIcon />
            </Button>
          )}
        </Box>
      )}
      renderOption={(props, option) => (
        <ListItem
          {...props}
          key={option.value}
          style={{
            minWidth: minWidthOption ?? "200px",
            maxWidth: maxWidthOption,
          }}
        >
          <Stack>
            <Typography>
              {option?.label?.length > 40
                ? `${option?.label?.substring(0, 40)}...`
                : option?.label}
            </Typography>
          </Stack>
        </ListItem>
      )}
    />
  );
}

export default AutoCompleteMultiSelect;